export default {
    path: '/organ',
    components: {
        default: () => import(/* webpackChunkName: "organ" */ '../views/ChildContainer'),
        menu: () => import(/* webpackChunkName: "organ-menu" */ '../views/organ/Menu'),
    },
    children: [
        {
            path: '',
            name: 'OrganHome',
            component: () => import(/* webpackChunkName: "organ-home" */ '../views/Home'),
        },
        {
            path: 'info-edit',
            name: 'OrganInfoEdit',
            component: () => import(/* webpackChunkName: "organ-info-edit" */ '../views/organ/OrganInfoEdit'),
        },
        {
            path: 'personManage',
            name: 'OrganPersonManage',
            component: () => import(/* webpackChunkName: "organ-person-manage" */ '../views/organ/OrganPersonManage'),
        },
        {
            path: 'courseManage',
            name: 'OrganCourseManage',
            component: () => import(/* webpackChunkName: "organ-person-manage" */ '../views/organ/OrganCourseManage'),
        },
        {
            path: 'studentManage',
            name: 'OrganStudentManage',
            component: () => import(/* webpackChunkName: "organ-student-manage" */ '../views/organ/OrganStudentManage'),
        },

        {
            path: 'projectManage',
            name: 'OrganProjectManage',
            component: () => import(/* webpackChunkName: "organ-project-manage" */ '../views/organ/OrganProjectManage'),
        },
        {
            path: 'projectEdit/:projectId',
            name: 'OrganProjectEdit',
            component: () => import(/* webpackChunkName: "organ-project-edit" */ '../views/organ/OrganProjectEdit'),
        },
        {
            path: 'projectAdd/:batchId',
            name: 'OrganProjectAdd',
            component: () => import(/* webpackChunkName: "organ-project-add" */ '../views/organ/OrganProjectAdd'),
        },
        {
            path: 'classExecute/:classId',
            name: 'OrganClassExecute',
            component: () => import(/* webpackChunkName: "organ-class-execute" */ '../views/organ/OrganClassExecute'),
        },


        {
            path: 'projectClassManage/:classId',
            name: 'OrganProjectClassManage',
            component: () => import(/* webpackChunkName: "organ-project-class-manage" */ '../views/organ/OrganProjectClassManage'),
        },
        {
            path: 'studyManage/:classId',
            name: 'OrganProjectClassManage',
            component: () => import(/* webpackChunkName: "organ-project-class-manage" */ '../views/organ/OrganProjectClassManage'),
        },
        {
            path: 'certificateManage/:classId',
            name: 'OrganCertificateManage',
            component: () => import(/* webpackChunkName: "organ-certificate-manage" */ '../views/organ/OrganCertificateManage'),
        },
        {
            path: 'certificateDataManage',
            name: 'OrganCertificateDataManage',
            component: () => import(/* webpackChunkName: "organ-certificate-data-manage" */ '../views/organ/OrganCertificateDataManage'),
        },
    ]
}
